<div class="date-time-field" [formGroup]="parentForm">
  <mat-form-field [appearance]="appearance" [color]="color">
    <mat-label>{{label}}</mat-label>
    <app-mat-datetime [formControlName]="name" #dateTimeInput="matDatetime"></app-mat-datetime>
    @if (hasActionObservers) {
      <button mat-icon-button matPrefix (click)="dateTimeInput.togglePicker()">
        <mat-icon>today</mat-icon>
      </button>
    }
    @if (!hasActionObservers) {
      <button mat-icon-button matSuffix (click)="dateTimeInput.togglePicker()">
        <mat-icon>today</mat-icon>
      </button>
    }
    @if (hasActionObservers && !processing) {
      <button mat-button matSuffix color="primary" (click)="performAction()">Save</button>
    }
    @if (processing) {
      <mat-spinner matSuffix diameter="24"></mat-spinner>
    }
  </mat-form-field>
</div>
